module.exports = __webpack_public_path__ + "img/MEDIA036.d8c62193.jpg";